import React, { Component } from 'react';
import FileUploaderBlob from '../../../commons/FileUploaderBlob.js';
import DownloadFile from '../../../commons/DownloadFile.js';
import DateSelector from '../../../commons/DateSelector.js';
import CONF from '../../../config/config.js';
import ErrorBox from '../../../commons/ErrorBox.js';

const datefor = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
});

export default class CrateSticker extends Component {
	constructor(props) {
        super(props);
        this.state = {
            selectedDate: null,
			selectedFacility: {},
			error: null,
        };
        this.dateSelected = this.dateSelected.bind(this);
        this.closeError = this.closeError.bind(this);
		this.errorCallback = this.errorCallback.bind(this);
    }
	componentDidMount() {
		var date = this.dates()[1]? this.dates()[1] : this.dates()[0];
        var facility = JSON.parse(localStorage.getItem('selectedFacility'));
        if (!facility) {
			this.setState({selectedDate: date, error: "Please select a facility" });
        } else {
            this.setState({ selectedFacility: facility, selectedDate: date, error: null });
        }
        
    }
	
	dates() {
		if(!this.state.selectedFacility) return [];
		var dates = [];
        var todayDate = new Date();
        todayDate.setHours(5, 30, 0, 0);
        var dateMillis = Date.parse(todayDate);

		const daysToAdd = CONF.specialDateFacilitiesD4.includes(this.state.selectedFacility.facilityName) ? 4 :
                      CONF.specialDateFacilitiesD3.includes(this.state.selectedFacility.facilityName) ? 3 :
                      CONF.specialDateFacilitiesD2.includes(this.state.selectedFacility.facilityName) ? 2 : 1;

		for (var i = 0; i <= daysToAdd; i++) {

			dates.push({
				deliveryDate: datefor.format(dateMillis),
				epochTime: dateMillis,
			});

			dateMillis += 86400000; // Add one day in milliseconds
		}
        return dates;
    }
	dateSelected(date) {
        this.setState({ selectedDate: date });
    }

	closeError() {
        this.setState({
            error: null,
        });
    }

	errorCallback() {
		this.setState({
			error: "Something went wrong while downloading the file",
		});
	}

	render(){
		return(
			<div>
				{this.state.error && <ErrorBox
					errorText={this.state.error}
					closeError={this.closeError}
				/>} 
				<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Crate Sticker Dump
					</div>
					<div className="crate-sticker-wrapper">
					<div>
						<DownloadFile title="Download Crate Sticker" url={`dump/parcel-sticker?facilityId=${this.state.selectedFacility.facilityId}&deliveryDateEpoch=${this.state.selectedDate ? this.state.selectedDate.epochTime : 0}`} errorCallback={this.errorCallback}/>
					</div>
					<div>
						<DateSelector
                            dates={this.dates()}
                            selected={this.state.selectedDate}
                            classes={'pull-right'}
                            dateSelected={this.dateSelected}
                    	/>
					</div>
					</div>
					{/* <div className="top-thirty">
						<FileUploaderBlob url="ingest/dispatch/vehicle-mapping"/>
					</div> */}
				</div>
			</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/DispatchJobs/Components/CrateSticker.js